module.exports = __webpack_public_path__ + "media/images/athletes/1730-31b4ff794b162d0af89de1ac387676d1.png";